import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';
import { Specialization } from '../../models/OutgoingCalls/Doctors';

export interface SpecializationState {
  specializations: Specialization[];
  status: Status;
}

const initialState: SpecializationState = {
  specializations: [],
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getSpecializationDoctor = createAsyncThunk(
  'specializationDoctor/getSpecializationDoctor',
  async (_, { rejectWithValue }) => {
    try {
      const response =
        await apiClientWithApi.get<Specialization[]>('specialization');
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else
        return rejectWithValue('Не удалось получить список специализаций!');
    }
  },
);

export const specializationDoctorSlice = createSlice({
  name: 'specialization',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getSpecializationDoctor.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getSpecializationDoctor.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.specializations = action.payload;
        return state;
      })
      .addCase(getSpecializationDoctor.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось получить список специализаций';
      });
  },
});

export default specializationDoctorSlice.reducer;

export const selectSpecializations = (state: RootState) =>
  state.specializations.specializations;
